<div class="not-in-your-state">
  <h3 data-test="quick-intake-form-not-in-your-state-header">Let's stay in touch.</h3>
  <p
    data-test="quick-intake-form-not-in-your-state-paragraph"
  >
    We're not in your state yet. Sign up for SonderMind updates and be the first to know when we are.
  </p>
  <a
    class="iris-button iris-button--secondary"
    target="_blank"
    [href]="comingToYourStateLink"
    data-test="quick-intake-form-sign-up-link"
  >
    Sign up
  </a>
</div>
